<div class="main-padding">
  <h3 class="header-bottom header-text1">{{ 'POINT.EDIT_TITLE' | translate }}</h3>
  <div class="text-center">
    <div class="text-center finish">
      {{ 'POINT.COMPLETED_TEXT' | translate }}
    </div>
    <div class="text-center">
      <div class="col-12">
        <div class="display finish2">
          <a (click)="back()" class="btn-grey">
            {{ 'POINT.RETURN_TO_PT_POINT_GRANT' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>     
</div>